export default "__VITE_ASSET__mesNXau7__"